export const TOGGLE_VIDEO = "TOGGLE_VIDEO";
export const TOGGLE_AUDIO = "TOGGLE_AUDIO";

export const INCOMMING_CALL = "INCOMMING_CALL";
export const CLOSE_INCOMMING_CALL = "CLOSE_INCOMMING_CALL";
